import { render } from "./TorneiDataTable.vue?vue&type=template&id=7f4662b7&scoped=true"
import script from "./TorneiDataTable.vue?vue&type=script&lang=js"
export * from "./TorneiDataTable.vue?vue&type=script&lang=js"

import "./TorneiDataTable.vue?vue&type=style&index=0&id=7f4662b7&scoped=true&lang=css"

import exportComponent from "/var/www/html/levante_web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f4662b7"]])

export default __exports__